import actions from '../action/wechat'
import CONSTANT from '../constant/wechat'

const openId = ''

export default {
  actions,
  state: {
    openId,
  },
  mutations: {
    [CONSTANT.WECHAT_GET_OPENID_SUCCESS](state, data) {
      return state.openId = data.openId
    },
    [CONSTANT.WECHAT_GET_OPENID_ERROR](state, e) {
      return state.openId = ''
    },
  }
}
